// confirm_modal.js (o donde manejes tus modales turbo)

export function openConfirmModal(message) {
  const dialog = document.getElementById("turbo-confirm");

  // Fallback a confirm() si no existe el modal
  if (!dialog || !HTMLDialogElement.prototype.showModal) {
    return Promise.resolve(confirm(message));
  }

  // Setea el texto del mensaje
  dialog.querySelector("[data-behaviour='title']").textContent = message;

  // Abre el modal
  dialog.showModal();

  // Retorna una promesa que se resuelve cuando el usuario decide
  return new Promise((resolve) => {
    dialog.addEventListener(
      "close",
      () => {
        resolve(dialog.returnValue === "confirm");
      },
      { once: true }
    );
  });
}

window.openConfirmModal = openConfirmModal;
Turbo.setConfirmMethod(openConfirmModal);
